var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.model.id)?_c('v-card',{staticClass:"elevation-2",attrs:{"tile":""}},[_c('v-card-text',[_c('v-row',{attrs:{"dense":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('DataTableMain',{attrs:{"datatable":_vm.table,"on-success":_vm.successAction,"items-action":_vm.tableAction}})],1)],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }